<div class="custom-tooltip" [style.background-color]="color">
    <p><img class="imageSize" *ngIf="imageSrc != 'No Image Found'" [src]="imageSrc"/></p>
    <p><img class="imageSize" *ngIf="imageSrc == 'No Image Found'" src="assets/images/No_Image.png"/></p>
</div>